export default {
    'training-details': 'تفاصيل التدريب',
    days: 'أيام',

    tabs: {
        'training-requirements': 'متطلبات التدريب',
        'training-plan': 'خطة التدريب',
        trainees: 'المتدربين',
        'training-rate': 'تقييم التدريب',
    },
}